import styled from "@emotion/styled";
import {Link as RemixLink} from "../../elements/link";

export const Hashtag = styled.div(({theme, styles}) => ({
  position: "relative",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  textDecoration: "none",
  width: "auto",
  height: "fit-content",
  margin: 0,
  fontSize: "0.75rem",
  lineHeight: 1.3,
  fontFamily: theme?.font?.manrope,
  fontWeight: 700,
  letterSpacing: "0.2px",
  whiteSpace: "nowrap",
  textTransform: "uppercase",
  ...styles,
  // ":hover": {
  //   ":after": {
  //     content: "''",
  //     position: "absolute",
  //     bottom: -3,
  //     left: 0,
  //     width: "0%",
  //     height: 2,
  //     backgroundColor: theme?.colors?.brandLightBlue,
  //     WebkitClipPath: "polygon(0% 100%, 1% 0%, 100% 0%, 99% 100%)",
  //     clipPath: "polygon(0% 100%, 1% 0%, 100% 0%, 99% 100%)",
  //     animation: "underlineAnimation 0.3s forwards",
  //   },
  // },
  // "@keyframes underlineAnimation": {
  //   to: {
  //     width: "100%",
  //   },
  // },
}));

export const StyledLink = styled(RemixLink)(({theme, color = "black"}) => ({
  textDecoration: "none",
  color: color === "white" ? theme?.colors?.primaryWhite : theme?.colors?.primaryBlack,
}));
